const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("Token") || "";
  config.headers.Lang =
    localStorage.getItem("setlanguage") ||
    localStorage.getItem("detectedLanguage") ||
    "en";
  return config;
});

const state = {
  page: 1,
  validInterest: "false",
  validGeo: "true",
  tagIcons: [
    //TODO i18 på label av knappene
    {
      id: 1,
      icon: "fas fa-hashtag",
      label: "Interest Tags",
      status: "active",
      count: 0,
      color: "white",
    },
    {
      id: 2,
      icon: "fas fa-map-marker-alt",
      label: "Geo Tags",
      status: "",
      count: 0,
      color: "white",
    },
  ],
};

//Returns modified value of state data
const getters = {};

//Change value of state data
const mutations = {
  changePage(state, payload) {
    state.page = payload.newPage;
  },
  validateInterest(state, payload) {
    state.validInterest = payload.status;
  },
  validateGeo(state, payload) {
    state.validGeo = payload.status;
  },
  changeActiveStatus(state, payload) {
    state.tagIcons[payload.index].status = payload.status;
  },
};

const actions = {
  GET_INTERESTS({ commit }, Data) {
    // console.log("Store interests with ", Data)
    return new Promise((resolve, reject) => {
      axios
        .post("tags/suggestions", Data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  GET_GEO({ commit }, Data) {
    // console.log("Store GEO with ", Data);
    return new Promise((resolve, reject) => {
      axios
        .post("geo/suggestion", Data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  actions,
  state,
  mutations,
  getters,
};
